import React from "react";

const TYPE_LABEL = {
  ARTICLE: "Статья",
  RECIPE: "Рецепт",
  FORMULATION: "Рецептура",
  GUIDE: "Гайд",
  REFERENCE: "Справочник",
};

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function renderBody(body) {
  if (!body) return "<p>Содержимое будет добавлено скоро.</p>";
  if (/^\s*<(?:p|h[1-6]|ul|ol|blockquote|hr|img|figure|div|span|strong|em|a)/i.test(body)) {
    return body;
  }
  return body
    .split(/\n{2,}/)
    .map((p) => `<p>${escapeHtml(p).replace(/\n/g, "<br/>")}</p>`)
    .join("");
}

/**
 * Shared user-facing article renderer. Used by:
 *   - /library/:slug (public MaterialDetail)
 *   - /admin/preview/materials/:id (admin secure preview)
 * so that «Что видит админ в предпросмотре — то увидит ученик после публикации».
 *
 * Presentation only. All CTAs (save/like) live in the wrapper.
 */
export default function MaterialArticleView({ material, headerRight = null, testidPrefix = "material", contentRef = null }) {
  return (
    <article ref={contentRef} className="max-w-3xl mx-auto px-5 pt-4 pb-16">
      <div className="flex items-start justify-between gap-3">
        <div className="text-[10px] uppercase tracking-[0.28em] text-muted-foreground">
          {TYPE_LABEL[material.material_type] || material.material_type}
        </div>
        {headerRight}
      </div>

      <h1 className="font-serif text-4xl leading-tight text-espresso mt-2" data-testid={`${testidPrefix}-title`}>
        {material.title}
      </h1>
      {material.short_description && (
        <p className="text-lg text-muted-foreground mt-3" data-testid={`${testidPrefix}-short`}>
          {material.short_description}
        </p>
      )}

      {material.cover_image && (
        <figure className="mt-6" data-testid={`${testidPrefix}-cover-figure`}>
          <img
            src={material.cover_image}
            alt={material.title || ""}
            data-testid={`${testidPrefix}-cover-image`}
            className="block mx-auto max-w-full h-auto max-h-[70vh] rounded-3xl"
            onError={(e) => { e.target.parentElement.style.display = "none"; }}
          />
        </figure>
      )}

      <div
        className="anokina-content font-serif text-espresso mt-8 leading-relaxed text-[17px]"
        data-testid={`${testidPrefix}-body`}
        dangerouslySetInnerHTML={{ __html: renderBody(material.body) }}
      />
    </article>
  );
}
